import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import moment from "moment";
import TablaPresuAumentados from "./tablaPresupuestosAumentados";

import { Input, Textarea } from "../../ui/inputs/Input";
import { DangerButton, SuccessButton, PrimaryButton } from "../../ui/buttons/Button";
import { lpad } from "../../util/varios";

export const AumentosdePartidas = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  // const idusuario = JSON.parse(localStorage.getItem('idusuario'));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  // const espiritu = JSON.parse(localStorage.getItem('espiritu'));
  const anioefis = JSON.parse(localStorage.getItem("efiscalanio"));

  const [activate, setActivate] = useState(false);
  const [deshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [datospre, setDatospre] = useState([]);
  const [valida, setValida] = useState([]);
  const [val, setVal] = useState(0.0);
  const [val2, setVal2] = useState([]);
  const [tipomovimiento, setTipomovimiento] = useState(0);
  const [idpc, setIdpc] = useState([]);
  const [cat, setCat] = useState(0);
  const [pucc, setPucc] = useState(0);
  const [data, setData] = useState([]);
  const [body, setBody] = useState(null);
  const [codigo, setCodigo] = useState(0);
  const [numtrasla, setNumTrasla] = useState(0);
  const [chek, setChek] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  const txtFecha = useRef();
  const txtFechaAprobacion = useRef();
  const txtObservacion = useRef();
  const txtNp = useRef();
  const txtIdAumento = useRef();
  const txtCodigo = useRef();

  const onChange = (event) => {
    if (
      event.target.name === "descriaux" ||
      event.target.name === "ubicacion" ||
      event.target.name === "observacion"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (new Date(txtFecha.current.value).getFullYear() !== anioefis) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El año no debe ser diferente al año del Ejercicio Fiscal actual",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (txtFechaAprobacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha de Aprobación",
        icono: "informacion",
      });
      sigue = false;
      txtFechaAprobacion.current.focus();
    } else if (new Date(txtFechaAprobacion.current.value).getFullYear() !== anioefis) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El año no debe ser diferente al año del Ejercicio Fiscal actual",
        icono: "informacion",
      });
      sigue = false;
      txtFechaAprobacion.current.focus();
    } else if (txtObservacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa la Observación",
        icono: "informacion",
      });
      sigue = false;
      txtObservacion.current.focus();
    } else if (valida === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Cuenta Presupuestaria",
        icono: "informacion",
      });
      sigue = false;
    } else if (sigue) {
      let datos = [];
      if (operacion === 1) {
        for (let e = 0; e < data.length; e++) {
          datos.push({
            idcuenta: data[e].idcuenta,
            auxiliar: data[e].auxiliar,
            idefiscal: idefiscal,
            monto: data[e].monto,
            tipomov: tipomovimiento,
            fechamov: txtFecha.current.value,
            fechaapro: txtFechaAprobacion.current.value,
            observ: txtObservacion.current.value,
            idcat: data[e].idcat,
            idpuc: data[e].idpuc,
            adic: 1,
            idaumdis: numtrasla,
          });
        }
      } else if (operacion === 2 || operacion === 5) {
        for (let e = 0; e < datospre.length; e++) {
          datos.push({
            idcuenta: datospre[e].idcuenta,
            auxiliar: datospre[e].auxiliar,
            idefiscal: idefiscal,
            monto: datospre[e].monto,
            tipomov: datospre[e].tipo,
            fechamov: txtFecha.current.value,
            fechaapro: txtFechaAprobacion.current.value,
            observ: txtObservacion.current.value,
            idcat: datospre[e].idcategoriaprogramatica,
            idpuc: datospre[e].idpuc,
            adic: 1,
            idaumdis: datospre[e].idaumentodisminucion,
            idmovimiento: datospre[e].idmovimiento,
          });
        }
      } else if (operacion === 3) {
        for (let e = 0; e < data.length; e++) {
          datos.push({
            idcuenta: data[e].idcuenta,
            auxiliar: data[e].auxiliar,
            idefiscal: idefiscal,
            monto: data[e].monto,
            tipomov: tipomovimiento,
            fechamov: txtFecha.current.value,
            fechaapro: txtFechaAprobacion.current.value,
            observ: txtObservacion.current.value,
            idcat: data[e].idcat,
            idpuc: data[e].idpuc,
            adic: 1,
            idaumdis: props.presu.idaumentodisminucion,
          });
        }
      }

      setBody({
        operacion: operacion,
        movimientos: datos,
        idf: idefiscal,
        idad: operacion !== 3 ? 0 : props.presu.idaumentodisminucion,
      });

      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (operacion === 2) {
        msg = tipomovimiento === 8 ? "Esta Seguro de Reversar este Aumento?." : "Esta Seguro de Reversar esta Disminución";
      } else if (operacion === 5) {
        msg = tipomovimiento === 8 ? "Esta Seguro de Eliminar este Aumento?." : "Esta Seguro de Eliminar esta Disminución";
      } else if (operacion === 3) {
        msg = tipomovimiento === 8 ? "Esta Seguro de Editar este Aumento?." : "Esta Seguro de Editar esta Disminución";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/presupuesto/crearaumentodisminucion`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: tipomovimiento === 8 ? "Aumento Registrado Correctamente" : "Disminución Registrada Correctamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: tipomovimiento === 8 ? "Aumento Reversado Correctamente" : "Disminución Reversada Correctamente",
              icono: "exito",
            });
          } else if (operacion === 5) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Eliminado Correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: tipomovimiento === 8 ? "Aumento Editado Correctamente" : "Disminución Editadoa Correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setDatospre([]);
    setActivate(false);
    setChek(0);
    setValida([]);
    setVal(0.0);
    setVal2([]);
    setCat(0);
    setPucc(0);
    setData([]);
    setIdpc([]);
    setBody(null);
    setCodigo(0);
  };

  const handleCloseSi = () => {
    if (operacion === 1) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    } else if (operacion === 2) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    } else if (operacion === 5) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    } else if (operacion === 3) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const BaseDatos = (data) => {
    /* setValida(data[0].idcuenta); */
    setData(data);
    console.log(data);
  };

  const SeleccionarSequencia = () => {
    let endpoint = `${op.conexion}/api/presupuesto/sequenciaaumentodisminu`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setNumTrasla(response.data.numtrasla);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SeleccionarCodigo = () => {
    let endpoint = `${op.conexion}/api/presupuesto/ultimocodigoaumentodisminucion?idefiscal=${idefiscal}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          let codigo = response.data.codigo;
          let count = codigo + 1;
          setCodigo(count);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const imprimirAumentoDis = () => {
    var reporte = "Pres_SE_Aumento_Disminucion";
    
    var sql = "";
    
    sql =
      "AUM.idaumentodisminucion = " + txtIdAumento.current.value;
    var condicion = "";

    condicion = sql;
    window.open(
      op.reportes +
        "/contabilidadpresupuestaria?" +
        "reporte=" +
        reporte +
        "&CONDICION=" +
        condicion +
        "&TIPO=" +
        tipomovimiento +
        "&idefiscal=" +
        idefiscal,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        SeleccionarSequencia();
        SeleccionarCodigo();
        setTipomovimiento(props.tipomov);
        if (props.operacion !== 1) {
          setValues(props.presu);
          setDatospre(props.movi);
          /* setValida(props.presu.idcuenta); */
          txtIdAumento.current.value = props.presu.idaumentodisminucion;
          txtCodigo.current.value = lpad(props.presu.codigo.toString().trim(), "0000", 4);
        } else {
          txtObservacion.current.value = "";
          txtFecha.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
          txtFechaAprobacion.current.value =
            moment.utc(fechaSistema).format("YYYY-MM-DD");
          txtIdAumento.current.value = "";
          txtCodigo.current.value = "";
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? props.titulo
              : operacion === 2
                ? props.titulo
                : operacion === 3
                  ? props.titulo
                  : props.titulo}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} inverted></Dimmer>
        <div>
          <input type="hidden" ref={txtNp} />

          <fieldset className="col-12 m-0 p-2 d-flex gap-2 border-azul rounded">
            <legend className="float-none m-0 w-auto">Datos</legend>
            <div className="col-2 m-0 p-0">
              <Input
                label="Fecha:"
                type="date"
                disabled={
                  operacion === 4 || operacion === 5 || operacion === 2
                    ? true
                    : deshabilitado
                }
                defaultValue={
                  props.presu && props.presu.fechamov !== ""
                    ? moment.utc(props.presu.fechamov).format("YYYY-MM-DD")
                    : moment.utc(fechaSistema).format("YYYY-MM-DD")
                }
                id="inputDireccion"
                ref={txtFecha}
              />
            </div>
            <div className="col-2 m-0 p-0">
              <Input
                label="ID:"
                type="text"
                disabled
                id="inputId"
                ref={txtIdAumento}
              />
            </div>
            <div className="col-2 m-0 p-0">
              <Input
                label= {tipomovimiento === 8 ? "Aumento Nª:" : "Disminución Nª:"}
                type="text"
                disabled
                id="inputCodigo"
                ref={txtCodigo}
              />
            </div>
            <div className="col-3 m-0 p-0">
              <Input
                label="Fecha de Aprobación:"
                type="date"
                className="form-control text-uppercase"
                disabled={
                  operacion === 4 || operacion === 5 || operacion === 2
                    ? true
                    : deshabilitado
                }
                ref={txtFechaAprobacion}
                defaultValue={
                  props.presu && props.presu.fechaapro !== ""
                    ? moment.utc(props.presu.fechaapro).format("YYYY-MM-DD")
                    : moment.utc(fechaSistema).format("YYYY-MM-DD")
                }
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                id="inputDireccion"
              />
            </div>
            {props.presu && props.presu.reversado > 0 && operacion !== 1 && (
              <div className="col-3">
                <div className="input-group input-group-sm m-0 w-100">
                  <font color="red" size="1">
                    <h1 align="center">
                      <i>{tipomovimiento === 8 ? "¡ El Aunento está Reversado !" : "¡ La Disminución está Reversada !"}</i>
                    </h1>
                  </font>
                </div>
              </div>
            )}
          </fieldset>

          <fieldset className="row border-azul rounded mx-auto">
            <legend className="float-none m-0 w-auto">
              Detalles de Cuenta(s)
            </legend>

            <div className="col-md-12 px-0">
              <TablaPresuAumentados
                data={BaseDatos}
                camptab={tipomovimiento === 8 ? "Aumento" : "Disminuido"}
                datarecords={datospre}
                operacion={operacion}
              />
            </div>
          </fieldset>
          <fieldset className="col-12 m-0 mt-2 p-2 border-azul rounded ">
            <div className="col-12 m-0 p-0">
              <Textarea label='Observaciones'
                style={{ height: 50 }}
                name="observacion"
                onChange={onChange}
                disabled={
                  operacion === 4 || operacion === 5 || operacion === 2
                    ? true
                    : deshabilitado
                }
                defaultValue={
                  props.presu ? props.presu.observaciones.trim() : ""
                }
                placeholder="Descripción del Clasificador Presupuestario"
                id="inputDireccion"
                ref={txtObservacion}
              />
            </div>
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton onClick={onChangeValidar} disabled={operacion === 4 ? true : false}>
          Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar}>Cancelar</DangerButton>
        {props.presu && props.operacion === 4 && (
          <PrimaryButton onClick={imprimirAumentoDis} icon="fa-print">
            Imprimir
          </PrimaryButton>
        )}
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
